import {
    createImageGalleryComponent,
    ImageGallery,
} from '@vfde-brix/image-gallery';

/**
 * Mount image gallery component
 * @param container
 * @param images
 */
const mountImageGallery = (containerId: string, images: string[]): ImageGallery | null => {
    const containerElement = document.getElementById(containerId);

    if (!containerElement) {
        return null;
    }

    const items = [];

    for (const image of images) {
        items.push({
            imgSrc: image,
        });
    }

    return createImageGalleryComponent(containerElement, {
        items,
        business: {},
    });
};

export default mountImageGallery;
